import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "main-table" }
const _hoisted_2 = { class: "filter-form" }
const _hoisted_3 = { class: "button-opera" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("新增外呼线路")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("查看")
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("查看")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("上传坐席表")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")
  const _component_a_select = _resolveComponent("a-select")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_a_input_search = _resolveComponent("a-input-search")
  const _component_a_form = _resolveComponent("a-form")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_divider = _resolveComponent("a-divider")
  const _component_a_table = _resolveComponent("a-table")
  const _component_setting_modal = _resolveComponent("setting-modal")
  const _component_seat_modal = _resolveComponent("seat-modal")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_a_form, {
        model: _ctx.filter,
        layout: "inline",
        labelAlign: "right"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: _ctx.filter.supplierType,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filter.supplierType = $event)),
                placeholder: "请选择外呼服务商",
                onChange: _ctx.refresh,
                allowClear: true
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.supplierOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      key: item.value,
                      value: item.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "onChange"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: _ctx.filter.wayType,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filter.wayType = $event)),
                onChange: _ctx.refresh,
                placeholder: "请选择外呼模式",
                allowClear: true
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.callLineOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      key: item.value,
                      value: item.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "onChange"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "",
            name: "account"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input_search, {
                value: _ctx.filter.account,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filter.account = $event)),
                valueModifiers: { trim: true },
                placeholder: "请输入帐号名称",
                "allow-clear": true,
                onSearch: _ctx.refresh
              }, null, 8, ["value", "onSearch"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"]),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openSetting('add')))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_a_table, {
      scroll: _ctx.scroll,
      "data-source": _ctx.data,
      columns: _ctx.columns,
      loading: _ctx.loading,
      pagination: _ctx.pagination,
      ref: "tableElRef",
      onChange: _ctx.handleTableChange,
      "row-key": (record) => record.corpId
    }, {
      lineAccountSetting: _withCtx(({ record }) => [
        _createVNode(_component_a_button, {
          type: "link",
          onClick: ($event: any) => (_ctx.openSetting('view', record))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      seatTable: _withCtx(({ record }) => [
        (record.supplierType?.id == 0 || record.wayType?.id == 4)
          ? (_openBlock(), _createBlock("span", _hoisted_6, "--"))
          : (_openBlock(), _createBlock(_component_a_button, {
              key: 1,
              type: "link",
              onClick: ($event: any) => (_ctx.openSeat('view', record))
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 2
            }, 1032, ["onClick"]))
      ]),
      usedCompany: _withCtx(({ record }) => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(record.bizNameList, (item) => {
          return (_openBlock(), _createBlock("div", { key: item }, _toDisplayString(item), 1))
        }), 128))
      ]),
      actions: _withCtx(({ record }) => [
        _createVNode(_component_a_button, {
          type: "link",
          onClick: ($event: any) => (_ctx.openSetting('edit', record))
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 2
        }, 1032, ["onClick"]),
        _createVNode(_component_a_divider, { type: "vertical" }),
        _createVNode(_component_a_button, {
          type: "link",
          onClick: ($event: any) => (_ctx.delAction(record))
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 2
        }, 1032, ["onClick"]),
        _createVNode(_component_a_divider, { type: "vertical" }),
        (record.supplierType?.id == 1 && [0, 3].includes(record.wayType?.id))
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              type: "link",
              onClick: ($event: any) => (_ctx.openSeat('add', record))
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 2
            }, 1032, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["scroll", "data-source", "columns", "loading", "pagination", "onChange", "row-key"]),
    (_ctx.configState.visible)
      ? (_openBlock(), _createBlock(_component_setting_modal, {
          key: 0,
          value: _ctx.configState.value,
          type: _ctx.configState.type,
          onClose: _ctx.closeConfig
        }, null, 8, ["value", "type", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.seatState.visible)
      ? (_openBlock(), _createBlock(_component_seat_modal, {
          key: 1,
          value: _ctx.seatState.value,
          type: _ctx.seatState.type,
          onClose: _ctx.closeSeat
        }, null, 8, ["value", "type", "onClose"]))
      : _createCommentVNode("", true)
  ]))
}